import { useState, useEffect } from 'react';

const loadNextSphereFont = () => {
  return new Promise((resolve) => {
    const font = new FontFace('Next Sphere', 'url(./assets/fonts/NextSphere.otf)');
    font.load().then(() => {
      document.fonts.add(font);
      resolve();
    }).catch(() => {
      resolve();
    });
  });
};

const createHomeworkBanner = async () => {
  await loadNextSphereFont();

  const canvas = document.createElement('canvas');
  canvas.width = 1200;
  canvas.height = 300;
  const ctx = canvas.getContext('2d');

  const gradient = ctx.createLinearGradient(0, 0, 0, 300);
  gradient.addColorStop(0, '#ee5a24');
  gradient.addColorStop(1, '#d1451e');
  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, 1200, 300);

  ctx.fillStyle = 'white';
  ctx.font = 'bold 48px Next Sphere, Arial, sans-serif';
  ctx.textAlign = 'left';
  ctx.textBaseline = 'bottom';

  return canvas.toDataURL('image/png');
};

export { createHomeworkBanner };

export function useHomeworkBanner() {
  const [initialHomeworkBannerImage, setInitialHomeworkBannerImage] = useState(null);

  useEffect(() => {
    createHomeworkBanner().then(setInitialHomeworkBannerImage);
  }, []);

  return initialHomeworkBannerImage;
}
